import { ReactNode } from "react";
import { motion } from "framer-motion";

interface Props {
  title: string;
  badge?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export default function Card({ title, badge, actions, children }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-zinc-900/80 backdrop-blur-xl border border-zinc-800 rounded-2xl overflow-hidden"
    >
      <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-800">
        <div className="flex items-center gap-3">
          <h2 className="text-base font-semibold text-white">{title}</h2>
          {badge}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      <div className="p-6">{children}</div>
    </motion.div>
  );
}
